module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-windowPop', {
    attrs: {
      "render": _vm.show,
      "title": _vm.title,
      "tip": true,
      "noBtns": true,
      "height": _vm.read ? '500px' : '80%',
      "width": '1000px'
    },
    on: {
      "cancel": _vm.close
    }
  }, [_c('div', {
    attrs: {
      "slot": "tab-title"
    },
    slot: "tab-title"
  }, [(_vm.read || _vm.quit) ? _c('div', {
    class: {
      active: _vm.activeIndex == 4
    },
    on: {
      "click": function($event) {
        _vm.changeTab(4)
      }
    }
  }, [_vm._v("个人信息")]) : _vm._e(), _vm._v(" "), (!_vm.read && !_vm.quit) ? _c('div', {
    class: {
      active: _vm.activeIndex == 0
    },
    on: {
      "click": function($event) {
        _vm.changeTab(0)
      }
    }
  }, [_vm._v("个人信息")]) : _vm._e(), _vm._v(" "), (!_vm.read || _vm.quit) ? _c('div', {
    class: {
      active: _vm.activeIndex == 1
    },
    on: {
      "click": function($event) {
        _vm.changeTab(1)
      }
    }
  }, [_vm._v("结算明细")]) : _vm._e(), _vm._v(" "), (!_vm.read || _vm.quit) ? _c('div', {
    class: {
      active: _vm.activeIndex == 2
    },
    on: {
      "click": function($event) {
        _vm.changeTab(2)
      }
    }
  }, [_vm._v("职级明细")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      active: _vm.activeIndex == 3
    },
    on: {
      "click": function($event) {
        _vm.changeTab(3)
      }
    }
  }, [_vm._v("个人罚单")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-wrap"
  }, [(_vm.read || _vm.quit) ? _c('infoRead', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 4),
      expression: "activeIndex == 4"
    }],
    attrs: {
      "index": _vm.activeIndex,
      "id": _vm.user_id
    },
    on: {
      "getdata": _vm.getUser
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.read && !_vm.quit) ? _c('infoTpl', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 0),
      expression: "activeIndex == 0"
    }],
    attrs: {
      "index": _vm.activeIndex,
      "id": _vm.user_id
    },
    on: {
      "getdata": _vm.getUser
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.read || _vm.quit) ? _c('settle', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 1),
      expression: "activeIndex == 1"
    }],
    attrs: {
      "index": _vm.activeIndex,
      "id": _vm.user_id
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.read || _vm.quit) ? _c('rank', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 2),
      expression: "activeIndex == 2"
    }],
    attrs: {
      "index": _vm.activeIndex,
      "id": _vm.user_id
    }
  }) : _vm._e(), _vm._v(" "), _c('ticket', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 3),
      expression: "activeIndex == 3"
    }],
    attrs: {
      "index": _vm.activeIndex,
      "id": _vm.user_id
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-76c1c667!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/person-detail/person-pop-info.vue
// module id = 765
// module chunks = 1